export const ADMIN_TYPE = 'magento_admin_type';
export const GUEST_TYPE = 'magento_guest_type';
export const CUSTOMER_TYPE = 'magento_customer_type';
